<div class="card_color rounded-xl my-2 w-full py-6 px-4 text_white">
  <h2 class="text-md font-semibold mb-4 text-left ml-1">Creditos</h2>

  <div class="p-4 space-y-2 card_color rounded-lg">
    <!-- Créditos Section -->
    <div class="pb-3">
      <span class="text_white pb-2 block">Créditos</span>
      <div
        class="button_color_customize py-3 px-4 rounded-lg flex items-center text-lg gap-2"
      >
        <span class="text_yellow text-3x1 pt-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-poker-chip"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
            <path d="M12 3v4" />
            <path d="M12 17v4" />
            <path d="M3 12h4" />
            <path d="M17 12h4" />
            <path d="M18.364 5.636l-2.828 2.828" />
            <path d="M8.464 15.536l-2.828 2.828" />
            <path d="M5.636 5.636l2.828 2.828" />
            <path d="M15.536 15.536l2.828 2.828" />
          </svg>
        </span>
        {{ wallet.credits | number : "1.2-2" }}
      </div>
    </div>

    <hr class="border-white opacity-20" />

    <!-- Bonos Section -->
    <div>
      <span class="text_white pb-2 block">Bonos</span>
      <div
        class="button_color_customize py-3 px-4 rounded-lg flex items-center text-lg gap-2 mb-6"
      >
        <span class="text_yellow text-3x1 pt-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-poker-chip"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
            <path d="M12 3v4" />
            <path d="M12 17v4" />
            <path d="M3 12h4" />
            <path d="M17 12h4" />
            <path d="M18.364 5.636l-2.828 2.828" />
            <path d="M8.464 15.536l-2.828 2.828" />
            <path d="M5.636 5.636l2.828 2.828" />
            <path d="M15.536 15.536l2.828 2.828" />
          </svg>
        </span>
        {{ wallet.bonus | number : "1.2-2" }}
      </div>
    </div>

    <hr class="border-white opacity-20" />

    <!-- Valor de Crédito Section -->
    <span class="text_white pb-2 block">Valor de Crédito</span>
    <div class="button_color_customize py-3 px-4 rounded-lg text_white">
      <dd class="text-sm font-semibold text_gray flex items-center gap-2">
        <span class="text_yellow text-3x1 pt-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-poker-chip"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
            <path d="M12 3v4" />
            <path d="M12 17v4" />
            <path d="M3 12h4" />
            <path d="M17 12h4" />
            <path d="M18.364 5.636l-2.828 2.828" />
            <path d="M8.464 15.536l-2.828 2.828" />
            <path d="M5.636 5.636l2.828 2.828" />
            <path d="M15.536 15.536l2.828 2.828" />
          </svg>
        </span>
        <span class="text-2xl text_white">
          1 =
          {{ operator?.data.sellCreditValue | number : "1.2-2" }}
          {{ currencyCode }}
        </span>
      </dd>
    </div>

    <div class="p-1 rounded-lg text_white text-center text-sm mt-1">
      <p>
        Si deseas comprar o retirar créditos, por favor comunícate con nosotros.
      </p>
    </div>
  </div>
</div>
